import React, { useState, useEffect } from 'react'
import ToggleIcon from '../../asset/direction-down.svg'
import {
  AccordionContainer,
  AccordionButton,
  AccordionToggleIcon,
  AccordionDetails,
  AccordionText,
} from './style'

const AccordionItem = ({ item, ariaExpanded, ariaControls, ariaId }) => {
  const { title, details } = item
  const [expanded, setExpanded] = useState(ariaExpanded)
  useEffect(() => {
    setExpanded(ariaExpanded)
  }, [ariaExpanded])
  function handleToggle() {
    setExpanded(!expanded)
  }

  return (
    <AccordionContainer role="accordion">
      <AccordionButton
        onClick={() => handleToggle()}
        aria-controls={ariaControls}
        aria-expanded={expanded}
        aria-describedby={`see more about ${title}`}
        name={expanded ? 'accordion expanded' : 'accordion'}
        id={ariaId}
      >
        {title}
        <AccordionToggleIcon
          src={ToggleIcon}
          alt=""
          expanded={expanded}
        ></AccordionToggleIcon>
      </AccordionButton>
      <AccordionDetails aria-hidden={!expanded} id={ariaControls}>
        <AccordionText>{details}</AccordionText>
      </AccordionDetails>
    </AccordionContainer>
  )
}

export default AccordionItem

// item={item}
//           ariaExpanded={expandAll}
//           ariaControls={`${title}-${index}`}
//           ariaId={`accordion-${title}-${index}`}
